import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import {
  apiURI,
  authErrorRedirect,
  useServerSidePagination,
  ServerDataGridTable,
  buildCsvColumns,
  downloadCsvViaExport,
} from "../../common";
import { QualityReportDetailsDialog } from "./QualityReportDetailsDialog.component";
import { allQualityReportsColumnConfig } from "./functions";

export function AllQualityReports() {
  // Quality Reports ID from the URL (deep-link target for approval emails).
  const { id } = useParams();
  const history = useNavigate();

  // Server-side pagination + search + sort over the unioned current + historical
  // reports.
  const {
    rows,
    rowCount,
    paginationModel,
    setPaginationModel,
    searchModel,
    onSearchChange,
    onClearAllSearch,
    activeFilterCount,
    filterResetKey,
    sortModel,
    onSortChange,
  } = useServerSidePagination("qualityReports");

  const [rowData, setRowData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const openDetails = (data) => {
    setRowData(data);
    setOpenModal(true);
  };
  const handleClose = () => setOpenModal(false);
  const handleRowClick = (event) => openDetails(event.row);

  // Deep-link: open a specific report by id. It usually isn't on the loaded
  // page, so fetch it directly rather than scanning the current page.
  useEffect(() => {
    if (!id) return;
    axios
      .get(`${apiURI}/form/qualityReports/${id}`)
      .then((response) => openDetails(response.data))
      .catch((error) => authErrorRedirect(error?.response?.data, history));
  }, [id, history]);

  return (
    <span>
      <ServerDataGridTable
        title="Approved Quality Reports list"
        description="Click on a row to view the Quality Report or Download PDF"
        columnConfig={allQualityReportsColumnConfig}
        enableSearch
        rows={rows}
        rowCount={rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        getRowId={(row) => row.qualityReportsID}
        onRowClick={handleRowClick}
        searchModel={searchModel}
        onSearchChange={onSearchChange}
        onClearAllSearch={onClearAllSearch}
        activeFilterCount={activeFilterCount}
        filterResetKey={filterResetKey}
        sortModel={sortModel}
        onSortChange={onSortChange}
        onExport={() =>
          downloadCsvViaExport({
            list: "qualityReports",
            columns: buildCsvColumns(allQualityReportsColumnConfig),
            search: searchModel,
            sort: sortModel.length
              ? { field: sortModel[0].field, dir: sortModel[0].sort }
              : undefined,
            filename: `quality-reports_${new Date()
              .toISOString()
              .slice(0, 10)}.csv`,
          })
        }
      />
      {rowData && (
        <QualityReportDetailsDialog
          rowData={rowData}
          open={openModal}
          handleClose={handleClose}
        />
      )}
    </span>
  );
}
